import { connectedAccountsStore } from '../store/store';
import { ConnectionType } from '../store/schema/ConnectionType';
export function getConnectAdvancedSyncRequest() {
    var store = connectedAccountsStore();
    if (store.connectAdvancedState.connectionType !== ConnectionType.SmtpOnly) {
        return {
            DisplayName: store.connectAdvancedState.displayName || store.connectAdvancedState.emailAddress,
            EmailAddress: store.connectAdvancedState.emailAddress,
            IncomingUserName: store.connectAdvancedState.username,
            IncomingPassword: store.connectAdvancedState.password,
            TargetRootFolder: store.connectAdvancedState.useNewFolder
                ? store.connectAdvancedState.emailAddress
                : undefined,
            IncomingAuth: store.connectAdvancedState.connectionType === ConnectionType.ImapSmtp
                ? store.connectAdvancedState.incomingAuth
                : undefined,
            IncomingSecurity: store.connectAdvancedState.incomingSecurity,
            IncomingServer: store.connectAdvancedState.connectionType === ConnectionType.ImapSmtp
                ? store.connectAdvancedState.imapServer
                : store.connectAdvancedState.popServer,
            IncomingPort: parseInt(store.connectAdvancedState.incomingPort),
            SyncProtocol: store.connectAdvancedState.connectionType === ConnectionType.ImapSmtp
                ? 'Imap'
                : 'Pop',
            LeaveOnServer: store.connectAdvancedState.leaveCopy,
            SmtpServerName: store.connectAdvancedState.smtpServer,
            SmtpServerPort: parseInt(store.connectAdvancedState.outgoingPort),
            SmtpUserName: store.connectAdvancedState.useAltUsernamePassword
                ? store.connectAdvancedState.altUsername
                : undefined,
            SmtpPassword: store.connectAdvancedState.useAltUsernamePassword
                ? store.connectAdvancedState.altPassword
                : undefined,
            RemoteSendEnabled: store.connectAdvancedState.remoteSend,
        };
    }
    else {
        return {
            DisplayName: store.connectAdvancedState.displayName || store.connectAdvancedState.emailAddress,
            EmailAddress: store.connectAdvancedState.emailAddress,
            IncomingUserName: store.connectAdvancedState.username,
            IncomingPassword: store.connectAdvancedState.password,
            TargetRootFolder: store.connectAdvancedState.useNewFolder
                ? store.connectAdvancedState.emailAddress
                : undefined,
            IncomingSecurity: 'Ssl',
            IncomingPort: 995,
            LeaveOnServer: store.connectAdvancedState.leaveCopy,
            SyncProtocol: 'Unified',
            SmtpServerName: store.connectAdvancedState.smtpServer,
            SmtpServerPort: parseInt(store.connectAdvancedState.outgoingPort),
            SmtpUserName: store.connectAdvancedState.useAltUsernamePassword
                ? store.connectAdvancedState.altUsername
                : undefined,
            SmtpPassword: store.connectAdvancedState.useAltUsernamePassword
                ? store.connectAdvancedState.altPassword
                : undefined,
            RemoteSendEnabled: store.connectAdvancedState.remoteSend,
        };
    }
}
//# sourceMappingURL=getConnectAdvancedSyncRequest.js.map